const TYPE_ONE = 1

// V7.9 rule matrix: in type-one invoices the buyer (tob/tinb/bid) is optional only in these patterns.
const BUYER_OPTIONAL_TEMPLATE_NAMES = new Map<number, string>([
  [7, 'صادرات'],
  [11, 'بورس کالا'],
])

export const isInvoiceBuyerRequired = (invoiceType: number, invoiceTemplate: number) =>
  invoiceType === TYPE_ONE && !BUYER_OPTIONAL_TEMPLATE_NAMES.has(Number(invoiceTemplate))

export const optionalBuyerHint = (invoiceTemplate: number) => {
  const patternName = BUYER_OPTIONAL_TEMPLATE_NAMES.get(Number(invoiceTemplate))
  return patternName
    ? `طبق دستورالعمل سامانه مؤدیان، اطلاعات خریدار در الگوی ${patternName} اختیاری است.`
    : 'طبق دستورالعمل سامانه مؤدیان، اطلاعات خریدار در این صورتحساب اختیاری است.'
}
